import { fileProblem } from "@/lib/resumeImport/files";
import { readResumeFile } from "./resumeReader";
import { plainRefusal, UNREADABLE } from "./resumeRefusals";

/** Fewer characters than this is a scan or an empty file, not a resume. */
export const MIN_RESUME_CHARS = 40;

/** A resume's text, or why there is none. */
export type ResumeText = { text: string; problem: null } | { text: null; problem: string };

const OLD_WORD = "Save it as a PDF or DOCX, or paste the text.";

/** A byte order mark, which a text editor can leave at the start of a file. */
const BYTE_ORDER_MARK = /^\uFEFF/;

function extensionOf(name: string): string {
    const dot = name.lastIndexOf(".");
    return dot < 0 ? "" : name.slice(dot + 1).toLowerCase();
}

/**
 * The text of a resume file, read in the browser. The file is never sent
 * anywhere. A file that cannot be read comes back as a problem to show the
 * visitor, never as a throw. `stopped` ends the read for a person who moved on.
 */
export async function resumeTextOf(file: File, stopped: AbortSignal): Promise<ResumeText> {
    if (extensionOf(file.name) === "doc") return { text: null, problem: OLD_WORD };
    const refusal = fileProblem(file);
    if (refusal) return { text: null, problem: refusal };
    const read = await readResumeFile(file, stopped);
    if ("text" in read) return { text: read.text.replace(BYTE_ORDER_MARK, ""), problem: null };
    if ("refusal" in read) return { text: null, problem: plainRefusal(read.refusal) };
    return { text: null, problem: UNREADABLE };
}
